Controller.$inject = ['$timeout', '$element'];

function Controller($timeout, $element) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    self.handleBlur = () => {
        if (!self.ngModel) {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    self.clearInput = () => {
        self.ngModel = '';
        self.onClear();
    };

    self.handleChange = ($event) => {
        self.onChange({$event});
    };

    self.$postLink = () => {
        $timeout(() => {
            $element.addClass('d-flex hui-input-search');
            if (self.fullWidth) {
                $element.addClass('w-100');
            }

            if (self.fullHeight) {
                $element.addClass('h-100');
            }
        }, 0);
    };
}

export function HuiInputSearch() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            onClear: '&',
            onChange: '&',
            fullWidth: '<',
            fullHeight: '<',
            includeSearchIcon: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            startIcon: '?huiInputStartIcon',
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="end"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.ngModel"
                full-height="$huiCtrl.fullHeight"
                full-width="$huiCtrl.fullWidth"
                disabled="$huiCtrl.disabled"
            >
                
                <hui-input-start-icon ng-transclude ng-transclude-slot="startIcon"></hui-input-start-icon>
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                <hui-input-base-icon ng-if="!$huiCtrl.disabled && $huiCtrl.ngModel">
                     
                    <button type="button"
                            ng-click="$huiCtrl.clearInput()"
                            class="search-clear-icon"
                            aria-label="{{ 'Clear' | translate }}">
                            <span aria-hidden="true">&times;</span>
                    </button>
                </hui-input-base-icon>
                    <input type="text"
                           ng-model="$huiCtrl.ngModel"
                           ng-disabled="$huiCtrl.disabled"
                           placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                           name="{{$huiCtrl.hName}}"
                           class="hui-base-input"
                           ng-class="{'full-height': $huiInputCtrl.fullHeight}"
                           ng-focus="$huiCtrl.handleFocus()"
                           ng-blur="$huiCtrl.handleBlur()"
                           ng-change="$huiCtrl.handleChange($event)"/>
              </hui-input-base>
             `;
        }
    }
}

